// extracted by mini-css-extract-plugin
export default {"HoverEffect":"AffordableGateways_HoverEffect__gJrPb","budgettourcarousel":"AffordableGateways_budgettourcarousel__txRe8"};